export const AUTH_EXPIRED_EVENT_NAME = "warehouse:auth-expired";
export const ACCESS_DENIED_EVENT_NAME = "warehouse:access-denied";

export interface AuthExpiredEventDetail {
  reason: "missing_token" | "refresh_failed" | "unauthorized";
}

export interface AccessDeniedEventDetail {
  message: string;
  path?: string;
}

export function emitAuthExpiredEvent(
  detail: AuthExpiredEventDetail = { reason: "unauthorized" },
): void {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<AuthExpiredEventDetail>(AUTH_EXPIRED_EVENT_NAME, {
      detail,
    }),
  );
}

export function emitAccessDeniedEvent(detail: AccessDeniedEventDetail): void {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<AccessDeniedEventDetail>(ACCESS_DENIED_EVENT_NAME, {
      detail,
    }),
  );
}
